import React, { useState, useEffect } from "react";
import Header from "../sharedComponents/Header";
import LandingPageHeader from "../sharedComponents/LandingPageHeader";
import LandingPageCard from "../sharedComponents/LandingPageCard";
import "../../styles/LandingPageHeader.css";
import fallbackLogo from "../../assets/logos/BDOgs-white.svg";
import { getTenantInfo } from "../../resources/api.resource.ts";
import buildInfo from "../../buildInfo.json";

const LandingPage = ({ logedInUserMail }) => {
  const [tenantData, setTenantData] = useState({
    logoUrl: fallbackLogo,
    companyName: "Intelligent Virtual Assistant (IVA)",
    subscriptionTier: "Standard",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTenantData = async () => {
      try {
        const data = await getTenantInfo();

        setTenantData({
          logoUrl: data.logoUrl || fallbackLogo,
          companyName: data.companyName || "Intelligent Virtual Assistant (IVA)",
          subscriptionTier: data.subscriptionTier || "Standard",
        });
      } catch (err) {
        console.error("Failed to fetch tenant data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTenantData();
  }, []);

  if (loading) {
    return (
      <div className="LandingPageHeader loading">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="LandingPage landingpageclass">
      <div className="HeaderWithCover">
        <Header logoUrl={tenantData.logoUrl} logedInUserMail={logedInUserMail} />
        <LandingPageHeader companyName={tenantData.companyName} />
      </div>
      <LandingPageCard />
      <span className="build-version">v{buildInfo.version} &middot; {buildInfo.buildDate}</span>
    </div>
  );
};

export default LandingPage;
